import { css } from '@emotion/react';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { LinkComponent } from '~/_shared/baseComponents/links';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  MetricsDataLayerBannerComponent, metricsDataLayerBannerTextStyle,
} from './metricsDataLayerBanner.component';

const contentStyle = css({
  display: 'flex',
  gap: 10,
  marginTop: 4,
  justifyContent: 'space-between',
});

const retryLinkStyle = css({
  fontSize: 13,
  textDecoration: 'underline',
});

const warningIconStyle = (theme: Theme) => css({
  color: theme.textColors.warning,
});

export const MetricsDataLayerAgsErrorComponent = ({ onRetry }: { onRetry?: () => void }) => {
  const [t] = useTranslation();

  return (
    <MetricsDataLayerBannerComponent
      heading={t('Couldn’t load')}
      icon={faExclamationTriangle}
      iconStyle={warningIconStyle}
    >
      <div css={contentStyle}>
        <p css={metricsDataLayerBannerTextStyle}>{t('Something went wrong.')}</p>
        {onRetry && (
          <LinkComponent
            css={retryLinkStyle}
            path={null}
            onClick={onRetry}
          >
            {t('Try Again')}
          </LinkComponent>
        )}
      </div>
    </MetricsDataLayerBannerComponent>
  );
};
